import React from 'react';
import ReactDOM from 'react-dom/client';
import 'assets/styles/index.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';
import StrapiApolloProvider from 'services/graphql/apollo';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter future={{ v7_startTransition: true }}>
    <StrapiApolloProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </StrapiApolloProvider>
  </BrowserRouter>
);

reportWebVitals();
